import { NgModule, ModuleWithProviders, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { RESPONSE_LOGGER_TOKEN } from '@awp/http';
import { ResponseStoreLogger } from './data-response.logger';
import { dataReducer } from './state/reducer';
import { dataFeatureName } from './state/selectors';
import { DataEffects } from './state/effects';
import { SharedModule } from '@awp/shared';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(dataFeatureName, dataReducer),
    EffectsModule.forFeature([DataEffects]),
    SharedModule
  ]
})
export class DataApiModule {
  static forRoot(config: Provider): ModuleWithProviders {
    return {
      ngModule: DataApiModule,
      providers: [
        config
      ]
    };
  }

}
